import i18next from 'i18next';

i18next.addResources('es_CL', 'App', {
  commerceLogo: 'Commerce logo',
  pizza: 'Pizza'
});
